var _path, _g, _path2, _g2, _g3, _path3, _g4, _path4, _path5, _g5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyScreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 113,
    height: 128,
    viewBox: "0 0 113 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_215_9981",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 23,
    height: 128
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.537099 63.9193C0.537097 28.9229 5.53083 0.552651 11.6909 0.552651C17.851 0.552651 22.8447 28.9229 22.8447 63.9193C22.8447 98.9157 17.851 127.286 11.6909 127.286C5.53083 127.286 0.537101 98.9157 0.537099 63.9193Z",
    fill: "url(#paint0_linear_215_9981)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_215_9981)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.537099 63.9193C0.537097 28.9229 5.53083 0.552651 11.6909 0.552651C17.851 0.552651 22.8447 28.9229 22.8447 63.9193C22.8447 98.9157 17.851 127.286 11.6909 127.286C5.53083 127.286 0.537101 98.9157 0.537099 63.9193Z",
    fill: "url(#paint1_linear_215_9981)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_215_9981",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 23,
    height: 128
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_215_9981",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 23,
    height: 128
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.536054 63.9193C0.536052 28.9229 5.5298 0.552651 11.6899 0.552651C17.85 0.552651 22.8437 28.9229 22.8437 63.9193C22.8437 98.9157 17.85 127.286 11.6899 127.286C5.5298 127.286 0.536055 98.9157 0.536054 63.9193Z",
    fill: "url(#paint2_linear_215_9981)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_215_9981)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.536054 63.9193C0.536052 28.9229 5.5298 0.552651 11.6899 0.552651C17.85 0.552651 22.8437 28.9229 22.8437 63.9193C22.8437 98.9157 17.85 127.286 11.6899 127.286C5.5298 127.286 0.536055 98.9157 0.536054 63.9193Z",
    fill: "url(#paint3_linear_215_9981)"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_215_9981)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-4.31253 65.0502C-4.31253 30.0538 0.681206 1.68362 6.84129 1.68362C13.0014 1.68362 17.9951 30.0538 17.9951 65.0502C17.9951 100.047 13.0014 128.417 6.8413 128.417C0.681211 128.417 -4.31252 100.047 -4.31253 65.0502Z",
    fill: "#0F1048"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_215_9981",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 23,
    height: 128
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask4_215_9981",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 23,
    height: 128
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.536054 63.9193C0.536052 28.9229 5.5298 0.552651 11.6899 0.552651C17.85 0.552651 22.8437 28.9229 22.8437 63.9193C22.8437 98.9157 17.85 127.286 11.6899 127.286C5.5298 127.286 0.536055 98.9157 0.536054 63.9193Z",
    fill: "url(#paint4_linear_215_9981)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_215_9981)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.536054 63.9193C0.536052 28.9229 5.5298 0.552651 11.6899 0.552651C17.85 0.552651 22.8437 28.9229 22.8437 63.9193C22.8437 98.9157 17.85 127.286 11.6899 127.286C5.5298 127.286 0.536055 98.9157 0.536054 63.9193Z",
    fill: "url(#paint5_linear_215_9981)"
  })))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_215_9981)"
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M-25.1668 80.5694C-25.1668 80.5694 -18.4098 80.8927 -15.5001 80.5694C-12.5581 80.2461 -10.6183 80.8927 -8.67851 81.5393C-6.73871 82.1859 -4.47562 83.1558 -1.88922 81.8626C0.697172 80.5694 0.697172 80.2461 1.99037 80.5694C3.28357 80.8927 5.54666 82.5092 7.48646 81.8626C9.42625 81.216 10.4931 79.5995 12.0126 78.9529C13.5322 78.3063 17.0561 78.9529 17.0561 78.9529L17.832 55.3521L16.5388 51.7958C16.5388 51.7958 11.6893 51.7958 9.74955 51.1492C7.80975 50.5026 5.22336 48.2395 2.96027 48.2395C0.697171 48.2395 -3.50572 50.5026 -5.12222 50.1793C-6.73871 49.856 -10.6183 49.5327 -14.4979 49.5327C-18.3775 49.5327 -24.5202 49.856 -24.5202 49.856C-24.5202 49.856 -29.693 57.9385 -29.693 66.3442C-29.693 74.75 -25.1668 80.5694 -25.1668 80.5694Z",
    fill: "#6C6CFF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_215_9981",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -30,
    y: 48,
    width: 48,
    height: 35
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M-25.1658 80.5694C-25.1658 80.5694 -18.4089 80.8927 -15.4992 80.5694C-12.5571 80.2461 -10.6173 80.8927 -8.67754 81.5393C-6.73774 82.1859 -4.47465 83.1558 -1.88825 81.8626C0.698141 80.5694 0.698141 80.2461 1.99134 80.5694C3.28454 80.8927 5.54763 82.5092 7.48743 81.8626C9.42722 81.216 10.4941 79.5995 12.0136 78.9529C13.5331 78.3063 17.0571 78.9529 17.0571 78.9529L17.833 55.352L16.5398 51.7957C16.5398 51.7957 11.6903 51.7957 9.75052 51.1491C7.81073 50.5025 5.22433 48.2394 2.96123 48.2394C0.698139 48.2394 -3.50475 50.5025 -5.12125 50.1792C-6.73775 49.8559 -10.6173 49.5326 -14.4969 49.5326C-18.3765 49.5326 -24.5192 49.8559 -24.5192 49.8559C-24.5192 49.8559 -29.692 57.9384 -29.692 66.3442C-29.692 74.75 -25.1658 80.5694 -25.1658 80.5694Z",
    fill: "#6C6CFF"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_215_9981)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6611 70.8729C12.6611 70.8729 8.45824 76.6923 5.22524 75.7224C1.99225 74.7525 -0.270851 72.1661 -2.53395 74.1059C-4.79704 76.0457 -8.67664 76.369 -12.8795 75.0758C-17.0824 73.7826 -23.2251 72.1661 -23.2251 72.1661",
    stroke: "white",
    strokeWidth: 2.94756,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6914 59.8815C11.6914 59.8815 6.19532 57.9417 2.31573 58.9116C-1.56386 59.8815 -3.82696 62.7912 -8.02985 61.1747C-12.2327 59.5582 -15.4334 59.1056 -19.6686 60.1402",
    stroke: "white",
    strokeWidth: 2.94756,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.51803 49.2094C6.51803 49.2094 2.96173 59.8782 9.42773 82.5092",
    stroke: "white",
    strokeWidth: 2.94756,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3.98875 48.0799C-3.98875 48.0799 -3.8271 50.1813 -4.4737 53.7376C-5.1203 57.2939 -5.7669 66.0553 -4.4737 71.6807C-3.1805 77.3061 1.3457 85.0977 1.3457 85.0977",
    stroke: "white",
    strokeWidth: 2.94756,
    strokeMiterlimit: 10
  })))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.39155 100.612L8.07048 97.8317C8.10281 97.7024 8.29679 97.7024 8.32912 97.8317L9.00806 100.612C9.00806 100.644 9.04038 100.709 9.10504 100.709L11.8854 101.388C12.0148 101.42 12.0148 101.614 11.8854 101.647L9.10504 102.326C9.07271 102.326 9.00806 102.358 9.00806 102.423L8.32912 105.203C8.29679 105.332 8.10281 105.332 8.07048 105.203L7.39155 102.423C7.39155 102.39 7.35922 102.326 7.29456 102.326L4.51417 101.647C4.38485 101.614 4.38485 101.42 4.51417 101.388L7.29456 100.709C7.35922 100.677 7.39155 100.644 7.39155 100.612Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3677 90.269L11.7557 88.5878C11.788 88.5232 11.885 88.5232 11.9173 88.5878L12.3053 90.269C12.3053 90.3013 12.3376 90.3337 12.37 90.3337L14.0511 90.7216C14.1158 90.754 14.1158 90.8509 14.0511 90.8833L12.37 91.2712C12.3376 91.2712 12.3053 91.3036 12.3053 91.3359L11.9173 93.0171C11.885 93.0817 11.788 93.0817 11.7557 93.0171L11.3677 91.3359C11.3677 91.3036 11.3354 91.2712 11.3031 91.2712L9.62191 90.8833C9.55725 90.8509 9.55725 90.754 9.62191 90.7216L11.3031 90.3337C11.3354 90.3013 11.3354 90.269 11.3677 90.269Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.16942 39.2844L9.71902 36.9567C9.75135 36.8597 9.913 36.8597 9.913 36.9567L10.4626 39.2844C10.4626 39.3167 10.4949 39.3491 10.5273 39.3491L12.855 39.8987C12.952 39.931 12.952 40.0927 12.855 40.0927L10.5273 40.6423C10.4949 40.6423 10.4626 40.6746 10.4626 40.7069L9.913 43.0347C9.88067 43.1317 9.71902 43.1317 9.71902 43.0347L9.16942 40.7069C9.16942 40.6746 9.13708 40.6423 9.10476 40.6423L6.77702 40.0927C6.68003 40.0603 6.68003 39.8987 6.77702 39.8987L9.10476 39.3491C9.13708 39.3814 9.16942 39.3491 9.16942 39.2844Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7953 77.1763C29.7953 77.1763 33.5456 78.7928 34.5155 77.6612C35.453 76.5297 37.5222 74.6545 37.4575 67.348C37.3928 60.0414 36.5199 54.416 35.9703 53.1875C35.453 51.9589 34.4831 49.0492 31.7351 51.3123C28.987 53.5754 28.6637 65.5375 28.6637 65.8608C28.6637 66.1841 29.7953 77.1763 29.7953 77.1763Z",
    fill: "#0F1048"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7955 64.2449C29.7955 56.6564 31.5325 50.5047 33.6751 50.5047C35.8177 50.5047 37.5547 56.6564 37.5547 64.2449C37.5547 71.8334 35.8177 77.9851 33.6751 77.9851C31.5325 77.9851 29.7955 71.8334 29.7955 64.2449Z",
    stroke: "#6C6CFF",
    strokeWidth: 2.94756,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M14.7624 76.8495C14.7624 76.8495 11.8527 73.2932 10.8828 68.4437C9.91292 63.5942 9.58962 50.9855 9.58962 50.9855L16.3789 51.9554L15.0857 66.5039L14.7624 76.8495Z",
    fill: "#0F1048"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M82.3329 58.133C82.3329 58.133 92.0966 59.5878 92.8402 60.0404C93.6161 60.493 100.793 66.0861 101.44 66.7327C102.087 67.3793 105.578 71.5175 105.578 71.5175C105.578 71.5175 105.901 73.7483 104.932 74.7182C103.962 75.6881 101.117 75.0415 99.5001 73.7483C97.8836 72.4551 95.6852 70.5476 95.6852 70.5476C95.6852 70.5476 90.5771 68.4139 90.2538 67.5733C90.2538 67.5733 81.654 66.0861 79.7466 64.5019C77.8391 62.9178 82.3329 58.133 82.3329 58.133Z",
    fill: "url(#paint6_linear_215_9981)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5903 49.0167C82.5903 49.0167 92.2246 48.5641 93.8087 48.5641C95.3929 48.5641 104.639 53.6722 105.254 53.9955C105.9 54.3188 111.267 59.2653 111.752 59.33C112.237 59.3946 112.204 61.2698 111.752 62.4013C111.299 63.5329 109.715 63.8562 107.484 63.2419C105.254 62.5953 100.566 59.33 100.566 59.33C100.566 59.33 93.4531 57.4872 92.8065 56.2263C92.8065 56.2263 85.4999 58.1984 82.2993 56.7436C82.3316 56.7113 80.6181 53.3166 82.5903 49.0167Z",
    fill: "url(#paint7_linear_215_9981)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6183 53.5406C27.1445 53.6053 31.9293 53.6376 35.5503 53.6053C41.2403 53.573 46.8334 52.3121 51.3919 50.0813C58.3752 46.622 54.4309 79.2429 48.7085 77.8204C43.5358 76.5272 42.8568 74.1348 39.2359 73.9084C37.2638 73.7791 29.6986 74.0701 22.489 74.3611C15.0531 74.652 15.1501 53.4436 22.6183 53.5406Z",
    fill: "#FDBC9D"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7135 50.0807C50.7135 50.0807 61.5763 45.0696 66.3611 43.4531C71.146 41.8689 74.9609 40.5757 77.1917 41.5456C79.4224 42.5155 82.7847 46.7507 83.011 51.9559C83.2374 57.161 77.515 71.5155 76.5451 73.0996C75.5752 74.6838 70.1761 74.0695 69.8528 73.4229C69.8528 73.4229 63.1605 77.5935 53.5908 77.8845C45.1204 78.1431 44.7971 77.1732 42.243 69.9313C39.8829 63.0127 42.4047 54.1543 50.7135 50.0807Z",
    fill: "url(#paint8_linear_215_9981)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M75.3489 41.2253C75.3489 41.2253 87.8929 36.2788 88.8628 35.9878C89.8326 35.6645 104.478 33.1105 106.062 32.7872C107.646 32.4639 108.94 33.1104 109.263 34.3713C109.586 35.6322 108.94 37.2487 106.386 38.5095C103.831 39.7704 100.954 40.7403 99.6933 40.417C99.6933 40.417 93.1626 43.456 91.8694 43.456C91.8694 43.456 85.1771 47.5943 81.6532 47.9176C81.6855 47.9176 75.3812 48.5318 75.3489 41.2253Z",
    fill: "url(#paint9_linear_215_9981)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M78.7105 66.6364C78.7105 66.6364 85.4674 68.9641 86.599 69.9017C87.7305 70.8716 95.3604 78.8248 95.6836 80.4089C96.0069 81.9931 93.7762 82.963 90.8988 81.6698C88.0215 80.3766 86.502 77.8872 86.502 77.8872C86.502 77.8872 82.9133 76.885 82.2991 74.6542C82.2991 74.6542 76.2534 74.0076 75.9301 73.07C75.6068 72.1325 75.7361 67.8326 78.7105 66.6364Z",
    fill: "url(#paint10_linear_215_9981)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5705 79.2771C15.5705 79.2771 12.3376 75.3975 12.3376 65.3752C12.3376 55.3529 15.7969 50.5034 15.7969 50.5034L33.8369 50.0185C33.8369 50.0185 29.9897 52.8635 29.8927 61.237C29.7957 69.5781 29.4077 76.6907 33.4813 78.3072L15.5705 79.2771Z",
    fill: "#6C6CFF"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6758 77.9851C31.542 77.9851 29.7962 71.8424 29.7962 64.2449C29.7962 56.6474 31.542 50.5047 33.6758 50.5047",
    stroke: "#6C6CFF",
    strokeWidth: 2.94756,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M0.537099 63.4365C0.537097 28.4401 5.53083 0.0698708 11.6909 0.0698705C17.851 0.0698702 22.8447 28.4401 22.8447 63.4365C22.8447 98.4329 17.851 126.803 11.6909 126.803C5.53083 126.803 0.537101 98.4329 0.537099 63.4365Z",
    fill: "url(#paint11_linear_215_9981)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M71.987 46.46C71.987 46.46 73.6035 49.3697 72.6336 55.5124C71.6637 61.655 69.3683 65.567 69.5623 69.1233C69.7239 72.6472 69.7239 72.6472 69.7239 72.6472C69.7239 72.6472 70.0472 68.7676 70.0472 67.7977C70.0472 66.8278 71.3728 63.1745 71.6637 62.3016C71.987 61.3317 74.8967 49.0464 71.987 46.46Z",
    fill: "#D86964"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M60.9618 67.7032C63.2896 66.9596 67.0075 64.5026 68.624 62.5951C70.2082 60.6876 71.1781 60.041 71.1781 60.041C71.1781 60.041 78.517 61.3019 82.6552 60.6876C86.7934 60.041 90.3174 57.196 90.3174 54.3186C90.3174 51.4413 89.3475 51.4413 88.4099 51.4413C87.4724 51.4413 82.9785 52.0879 81.3943 52.0879C79.8102 52.0879 70.9841 53.0578 68.527 51.4413C66.1023 49.8571 59.0867 49.2105 53.332 52.0879C47.6096 54.9652 46.3164 58.7802 46.963 63.2417C47.5772 67.7032 53.9462 69.934 60.9618 67.7032Z",
    fill: "#FDBC9D"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M83.6242 54.5435C83.6242 55.1901 84.2708 56.16 85.8873 56.16C87.5038 56.16 87.6654 56.16 87.6654 56.16C87.6654 56.16 88.1504 53.8969 88.1504 53.2503C88.1504 52.6037 88.1504 51.9248 88.1504 51.9248C88.1504 51.9248 83.6242 51.9572 83.6242 54.5435Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_215_9981",
    x1: 11.6909,
    y1: 127.275,
    x2: 11.6909,
    y2: 0.541495,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3068,
    stopColor: "#6C6CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5728,
    stopColor: "#19194F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8572,
    stopColor: "#6C6CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_215_9981",
    x1: 11.6909,
    y1: 127.275,
    x2: 11.6909,
    y2: 0.541495,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3068,
    stopColor: "#6C6CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5728,
    stopColor: "#19194F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8572,
    stopColor: "#6C6CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_215_9981",
    x1: 11.6899,
    y1: 127.275,
    x2: 11.6899,
    y2: 0.541495,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3068,
    stopColor: "#6C6CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5728,
    stopColor: "#19194F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8572,
    stopColor: "#6C6CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_215_9981",
    x1: 11.6899,
    y1: 127.275,
    x2: 11.6899,
    y2: 0.541495,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3068,
    stopColor: "#6C6CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5728,
    stopColor: "#19194F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8572,
    stopColor: "#6C6CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_215_9981",
    x1: 11.6899,
    y1: 127.275,
    x2: 11.6899,
    y2: 0.541495,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3068,
    stopColor: "#6C6CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5728,
    stopColor: "#19194F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8572,
    stopColor: "#6C6CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_215_9981",
    x1: 11.6899,
    y1: 127.275,
    x2: 11.6899,
    y2: 0.541495,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3068,
    stopColor: "#6C6CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5728,
    stopColor: "#19194F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8572,
    stopColor: "#6C6CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_215_9981",
    x1: 92.4638,
    y1: 75.1617,
    x2: 92.4638,
    y2: 58.1257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDBC9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F49A89"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_215_9981",
    x1: 101.162,
    y1: 56.4889,
    x2: 86.9783,
    y2: 52.3173,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDBC9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F49A89"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_215_9981",
    x1: 52.4507,
    y1: 64.5253,
    x2: 75.0625,
    y2: 57.3157,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDBC9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F49A89"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_215_9981",
    x1: 100.127,
    y1: 34.4453,
    x2: 82.1939,
    y2: 44.9747,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDBC9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F49A89"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_215_9981",
    x1: 85.7765,
    y1: 82.3056,
    x2: 85.7765,
    y2: 66.6443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDBC9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F49A89"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_215_9981",
    x1: 14.3211,
    y1: 63.4756,
    x2: -5.32706,
    y2: 63.1001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C6CFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C6CFF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyScreen);
export default __webpack_public_path__ + "static/media/empty_screen.62cb23d2144d9be6b0b5de55889b1431.svg";
export { ForwardRef as ReactComponent };